module.exports = __webpack_public_path__ + "static/movie-02-e0fc75f3798affb4fd6ae9be6cc3a264.mp4";